export default "__VITE_ASSET__dAsOjsnC__"